import React, { useContext, useEffect, useState } from 'react'
import { Grid, Loader } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../App/stores/RootStore'
import InfiniteScroll from 'react-infinite-scroller'
import AdminList from './AdminList'

const AdminDashboard: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { loadAdminSettings, setPage, page, totalPages } = rootStore.adminSettingStore;
    const { loadAdminDocuments, setPage: setPageReviewNotes } = rootStore.adminDocumentStore;
    const { loadAdminQuestions, setPage: setPageReviewDocumentNotes } = rootStore.adminQuestionStore;
    const [loadingNext, setLoadingNext] = useState(false);

    const handleGetNext = () => {
        setLoadingNext(true);
        setPage(page + 1);
        setPageReviewNotes(page + 1);
        setPageReviewDocumentNotes(page + 1);
        loadAdminSettings().then(() => setLoadingNext(false))
        loadAdminDocuments().then(() => setLoadingNext(false))
        loadAdminQuestions().then(() => setLoadingNext(false))
    }

    useEffect(() => {
        loadAdminSettings();
        loadAdminDocuments();
        loadAdminQuestions();
    }, [loadAdminSettings, loadAdminDocuments, loadAdminQuestions]);

    return (
        <Grid>
            <Grid.Column style={{ overflowY: "auto", maxHeight: "90vh", width: "100%" }}>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={handleGetNext}
                    hasMore={!loadingNext && page + 1 < totalPages}
                    initialLoad={false}
                >
                    <AdminList />
                </InfiniteScroll>
            </Grid.Column>

            <Grid.Column width={10}>
                <Loader active={loadingNext} />
            </Grid.Column>
        </Grid>
    )
}
export default observer(AdminDashboard);